
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/admin/events",
      function () {
        return require("private-next-pages/admin/events/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/admin/events"])
      });
    }
  